import Icon from '../components/Icon.vue'

Icon.register({"caret-right":{"width":640,"height":1792,"paths":[{"d":"M576 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-right.js
// module id = Oncp
// module chunks = 0